import { defineMessages, FormattedMessage, useIntl } from 'react-intl';

import ReplyIcon from '@/material-icons/400-24px/reply.svg?react';
import { Avatar } from 'mastodon/components/avatar';
import { Icon } from 'mastodon/components/icon';
import { useAppSelector } from 'mastodon/store';

import { LinkedDisplayName } from './display_name';

const messages = defineMessages({
  continuedThread: {
    id: 'status.continued_thread',
    defaultMessage: 'Continued thread',
  },
  repliedInThread: {
    id: 'status.replied_in_thread',
    defaultMessage: 'Replied in thread',
  },
});

// Rendered just above the post body (see `.status__thread-marker`). "Continued
// thread" / "Replied in thread" show only the arrow, with the text as a tooltip
// and accessible name; "Replied to <user>" keeps its label beside the arrow.
export const StatusThreadLabel: React.FC<{
  accountId: string;
  inReplyToAccountId: string;
}> = ({ accountId, inReplyToAccountId }) => {
  const intl = useIntl();
  const inReplyToAccount = useAppSelector((state) =>
    state.accounts.get(inReplyToAccountId),
  );

  if (accountId === inReplyToAccountId || !inReplyToAccount) {
    const label = intl.formatMessage(
      accountId === inReplyToAccountId
        ? messages.continuedThread
        : messages.repliedInThread,
    );

    return (
      <div className='status__thread-marker' title={label}>
        <Icon id='reply' icon={ReplyIcon} aria-label={label} />
      </div>
    );
  }

  return (
    <div className='status__thread-marker status__thread-marker--labelled'>
      <Icon id='reply' icon={ReplyIcon} />
      <Avatar
        account={inReplyToAccount}
        size={32}
        className='status__thread-marker__avatar'
      />
      <span>
        <FormattedMessage
          id='status.replied_to'
          defaultMessage='to {name}'
          values={{
            name: (
              <LinkedDisplayName
                displayProps={{ account: inReplyToAccount, variant: 'simple' }}
              />
            ),
          }}
        />
      </span>
    </div>
  );
};
